import KelompokUpahSubcont from './KelompokUpahSubcont';

export default KelompokUpahSubcont;
